import { MOBILE_SIZE_BREAKPOINT } from 'consts'
import { COLORS } from 'consts/colors'
import { Z_INDEX_FOR_HIDE_REACT_SELECTO_RECTANGLE_DURING_SCROLL_HEADER } from 'consts/zIndex'
import styled from 'styled-components'

export const Header = styled.div`
  position: relative;
  width: 100%;
  height: 44px;
  padding: 8px 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: ${Z_INDEX_FOR_HIDE_REACT_SELECTO_RECTANGLE_DURING_SCROLL_HEADER};
  background-color: ${COLORS.white};

  @media (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    padding: 8px 2px;
    height: 40px;
  }
`
